import Spinner from "@/components/Spinner";
import { getToken } from "@/hooks/utils";
import { useState } from "react";
import { toast } from "sonner";
import { endpoints } from "../../../hooks/endpoints";
import { useAppDispatch } from "../../../store/hooks";
import { invokeUserRefetch } from "../../../store/slices/storeSlice";

const WalletPurchase = ({ lessonData }) => {
  const dispatch = useAppDispatch();

  const [isPending, setIsPending] = useState(false);

  const handlePurchase = async () => {
    try {
      setIsPending(true);
      const res = await fetch(endpoints.walletPurchase, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: getToken(),
        },
        body: JSON.stringify({ lesson_id: lessonData.lesson_id }),
      });
      const response = await res.json();

      if (!res.ok) {
        throw new Error(
          response.data || "حدث خطأ أثناء عملية الشراء. يرجى المحاولة لاحقاً."
        );
      }

      toast.success(response.data || "تمت عملية الشراء بنجاح");
      dispatch(invokeUserRefetch());
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsPending(false);
    }
  };

  return (
    <div className="block">
      {!isPending && (
        <button
          className="block mx-auto px-6 py-2 bg-primary text-white font-bold rounded-lg hover:bg-primary/90 transition"
          onClick={handlePurchase}
        >
          شراء بالرصيد
        </button>
      )}

      {isPending && (
        <button
          type="button"
          disabled
          className="mx-auto px-6 py-2 bg-primary text-white font-bold rounded-lg cursor-not-allowed flex items-center gap-2"
        >
          <Spinner variant="button" />
          شراء بالرصيد...
        </button>
      )}
    </div>
  );
};

export default WalletPurchase;
